import React from "react";
import Card from "./Card";

import "./Things.scss";

const Things = ({
  things,
  selected,
  onSelect,
  cardAnimation,
  cardBackgroundColor,
  textColor,
  cardTextColor,
}) => {
  const cardStyle = {
    backgroundColor: cardBackgroundColor || undefined,
    color: cardTextColor || "#000000",
  };

  return (
    <div
      className={`Things ${
        cardAnimation === "correct" ? "animating-correct" : ""
      }`}
    >
      {things.map((thing, index) => (
        <Card
          key={index}
          thing={thing}
          selected={selected.includes(thing)}
          onSelect={onSelect}
          cardAnimation={cardAnimation}
          style={cardStyle}
        />
      ))}
    </div>
  );
};

export default Things;
